import styles from "./ITServicesManagementPolicyPage.module.css";

const ITServicesManagementPolicyPage = () => {
  return (
    <div className={styles.container}>
      <h1>Πολιτική Διαχείρισης Υπηρεσιών Πληροφορικής</h1>
      <p>
        Η εταιρεία <strong>THE RECORDS HUB S.A.</strong> δεσμεύεται να παρέχει
        ποιοτικές υπηρεσίες πληροφορικής, που καλύπτουν τις ανάγκες των πελατών,
        σύμφωνα με τις απαιτήσεις του προτύπου ISO 20000-1:2018 για τη
        Διαχείριση Υπηρεσιών Πληροφορικής. Στόχος μας είναι η συνεπής και
        αποδοτική παράδοση υπηρεσιών που βελτιώνουν την ικανοποίηση των πελατών
        και ενισχύουν την απόδοση της εταιρείας.
      </p>

      <p>
        Η εταιρεία αναγνωρίζει ότι η επιτυχία της εξαρτάται από την ικανότητα να
        παρέχει και να διαχειρίζεται αποτελεσματικές και αποδοτικές υπηρεσίες
        πληροφορικής. Δεσμευόμαστε να αναπτύξουμε και να εφαρμόσουμε τις
        κατάλληλες πρακτικές και διαδικασίες για την επίτευξη υψηλής ποιότητας
        στην παροχή υπηρεσιών.
      </p>

      <h2>
        Το Σύστημα Διαχείρισης Υπηρεσιών Πληροφορικής καλύπτει το παρακάτω
        πεδίο:
      </h2>
      <ul>
        <li>
          Ασφαλής Ψηφιοποίηση Αρχείων Πελατών της Εταιρείας μας σε Έντυπη Μορφή
        </li>
        <li>
          Ασφαλής Φύλαξη Αρχείων Πελατών της Εταιρείας μας σε Έντυπη ή/και
          Ηλεκτρονική Μορφή
        </li>
        <li>
          Ασφαλής Διαχείριση Αρχείων Πελατών της Εταιρείας μας σε Έντυπη ή/και
          Ηλεκτρονική Μορφή:
          <ul>
            <li>Μεταφορά</li>
            <li>Καταγραφή / Καταλογογράφηση</li>
            <li>Αρχειοθέτηση</li>
            <li>
              Προεπισκόπηση και Αναζήτηση Μεταδεδομένων στη Διαχείριση Αρχείων
            </li>
          </ul>
        </li>
        <li>
          Ασφαλής Καταστροφή Αρχείων Πελατών της Εταιρείας μας σε Έντυπη ή/και
          Ηλεκτρονική Μορφή
        </li>
        <li>
          Συμβουλευτικές Υπηρεσίες για τη Διαχείριση Αρχείων (Records
          Management) Πελατών της Εταιρείας μας
        </li>
        <li>Συμβουλευτικές Υπηρεσίες DPO / GDPR</li>
      </ul>

      <h2>Στρατηγικοί στόχοι της εταιρείας είναι:</h2>
      <ul>
        <li>
          Παροχή Υψηλής Ποιότητας Υπηρεσιών Πληροφορικής εξασφαλίζοντας ότι οι
          υπηρεσίες που παρέχονται καλύπτουν τις απαιτήσεις των πελατών, με
          συνέπεια και αξιοπιστία.
        </li>
        <li>
          Συνεχής Βελτίωση των Διαδικασιών Υπηρεσιών μέσω της συλλογής
          δεδομένων, της ανατροφοδότησης από τους πελάτες και της ανάλυσης
          επιδόσεων.
        </li>
        <li>
          Υλοποίηση διορθωτικών και προληπτικών μέτρων για τη βελτίωση των
          υπηρεσιών και την πρόληψη πιθανών προβλημάτων.
        </li>
        <li>Ευθυγράμμιση με τις Επιχειρηματικές Ανάγκες των Πελατών.</li>
        <li>
          Συμμόρφωση με όλους τους ισχύοντες κανονισμούς, πρότυπα και εσωτερικές
          πολιτικές που αφορούν τις υπηρεσίες πληροφορικής.
        </li>
        <li>
          Ενσωμάτωση των κατευθυντήριων γραμμών του ISO 20000-1 σε όλες τις
          διαδικασίες διαχείρισης υπηρεσιών μας.
        </li>
        <li>
          Άμεση ανταπόκριση σε Συμβάντα και Διαχείριση Προβλημάτων,
          διασφαλίζοντας ότι οι πελάτες λαμβάνουν άμεση και αποτελεσματική
          υποστήριξη.
        </li>
        <li>
          Υιοθέτηση στρατηγικών αποκατάστασης υπηρεσιών για την ελαχιστοποίηση
          των διαταραχών και την εξασφάλιση της επιχειρησιακής συνέχειας.
        </li>
        <li>Αποτελεσματική διαχείριση πόρων.</li>
        <li>
          Εξασφάλιση της επάρκειας των πόρων, τόσο ανθρώπινων όσο και
          τεχνολογικών, για την αποδοτική παροχή υπηρεσιών.
        </li>
        <li>
          Συνεχή εκπαίδευση του ανθρώπινου δυναμικού της εταιρείας για την
          απόκτηση των απαραίτητων δεξιοτήτων και γνώσεων στη διαχείριση
          υπηρεσιών πληροφορικής.
        </li>
      </ul>

      <p>
        Η εταιρεία δεσμεύεται να διασφαλίσει ότι το προσωπικό και οι συνεργάτες
        της κατανοούν την Πολιτική Παροχής Υπηρεσιών Πληροφορικής και είναι
        ενεργοί συμμετέχοντες στην επίτευξη των στόχων.
      </p>
      <p>
        Η Πολιτική Διαχείρισης Υπηρεσιών θα αναθεωρείται σε τακτά χρονικά
        διαστήματα από τη διοίκηση για να διασφαλίζεται ότι παραμένει κατάλληλη
        και αποτελεσματική, λαμβάνοντας υπόψη τις εξελίξεις στον τομέα των
        υπηρεσιών πληροφορικής και τις αλλαγές στις ανάγκες των πελατών.
      </p>
    </div>
  );
};

export default ITServicesManagementPolicyPage;
